import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { HttpService } from '../../core/services/http.service';
import { Params } from './pages/tabs/users/models/params.model';

@Injectable({ providedIn: 'root' })
export class MerchantSettingsService {

  private addUrl = 'merchants/settings/add-user';
  private saveAccountUrl = 'merchants/settings/save-account';
  private getAllUsersUrl = 'merchants/settings/all-users';
  private reportsUrl = 'merchants/settings/reports';

  private resendEmailUserUrl = 'merchants/settings/resend-email';

  private getServicesUrl = 'merchants/settings/movidesk-services';

  private getAllUsersMerchantUrl = 'merchants/settings/all-users-merchant';
  private createTicketMerchantUrl = 'merchants/settings/create-ticket';

  private downloReportUrl = 'merchants/settings/download-report';

  private profileUrl = 'merchants/settings/user';
  private updatePasswordUrl = 'merchants/settings/update-password';
  private updateUrl = 'merchants/settings/update-user';

  private accountsUrl = 'merchants/settings/accounts';
  private allAccountsUrl = 'merchants/settings/all-accounts';

  private enableUserUrl = 'merchants/settings/enable-user';
  private invoiceListUrl = 'merchants/settings/get-invoices';
  private circularizationLetterUrl = 'merchants/settings/circularization-letter';

  user: any;
  partner: any;

  private userSource = new BehaviorSubject<any>({});
  currentUser = this.userSource.asObservable();
  private partnerSource = new BehaviorSubject<any>({});
  currentParnter = this.partnerSource.asObservable();

  constructor(private httpService: HttpService) {
  }

  saveAccount(partner: string, account: string, merchant, params) {
    return this.httpService.postMerchant(this.saveAccountUrl, params, partner, account, merchant);
  }

  addUser(partner: string, account: string, merchant, params) {
    return this.httpService.postMerchant(this.addUrl, params, partner, account, merchant);
  }

  getServices(partner: string, account: string, merchant) {
    return this.httpService.getMerchant(this.getServicesUrl, partner, account, merchant, true);
  }

  accounts(partner: string, account: string, merchant) {
    return this.httpService.getMerchant(this.accountsUrl, partner, account, merchant, true);
  }

  allAccounts(partner: string, account: string, merchant) {
    return this.httpService.getMerchant(this.allAccountsUrl, partner, account, merchant, false);
  }

  profile(partner: string, account: string, merchant) {
    return this.httpService.getMerchant(this.profileUrl, partner, account, merchant, true);
  }

  updateUser(partner: string, account: string, merchant, params) {
    return this.httpService.postMerchant(this.updateUrl, params, partner, account, merchant);
  }

  updatePassword(partner: string, account: string, merchant, params) {
    return this.httpService.postMerchant(this.updatePasswordUrl, params, partner, account, merchant);
  }

  getAllUsers(partner: string, account: string, merchant, params: Params) {
    return this.httpService.postMerchant(this.getAllUsersUrl, params.createPost(), partner, account, merchant, true);
  }

  resendEmail(partner: string, account: string, merchant, params) {
    return this.httpService.postMerchant(this.resendEmailUserUrl, params, partner, account, merchant);
  }

  changeUser(user) {
    this.userSource.next(user)
  }
  changePartner(partner) {
    this.partnerSource.next(partner)
  }

  getAllUsersMerchant(partner: string, account: string, merchant: string, params) {
    return this.httpService.postMerchant(this.getAllUsersMerchantUrl, params, partner, account, merchant, true);
  }

  enableUser(partner: string, account: string, merchant, params) {
    return this.httpService.postMerchant(this.enableUserUrl, params, partner, account, merchant);
  }
  createTicketMerchant(partner: string, account: string, merchant: string, params) {
    return this.httpService.postMerchant(this.createTicketMerchantUrl, params, partner, account, merchant, true);
  }

  getReports(partner, account, merchant, params) {
    return this.httpService.postMerchant(this.reportsUrl, params, partner, account, merchant, true);
  }

  getReportsById(partner, account, merchant, id) {
    return this.httpService.getMerchant(`${this.reportsUrl}/${id}`, partner, account, merchant, false);
  }

  download(partner, account, merchant, params) {
    return this.httpService.postDownMerchant(this.downloReportUrl, params, partner, account, merchant, true, true);
  }

  invoiceList(partner: string, account: string, merchant: string, params) {
    return this.httpService.postMerchant(this.invoiceListUrl, params, partner, account, merchant, true);
  }
  downloadLetter(partner: string, account: string, merchant: string, date) {
    const params = {
      date
    }
    return this.httpService.postMerchant(this.circularizationLetterUrl, params, partner, account, merchant, true);
  }
}
